/**
 * Auth helpers — tiny React-Query wrappers around the auth endpoints.
 *
 * The whoami query is the source of truth for the top-level app state:
 *   - `state: 'bootstrap_required'` → show "Create owner account" on /login
 *   - `state: 'unauthenticated'`    → show login form on /login, gate other routes
 *   - `state: 'authenticated'`      → show the main app; role gates admin screens
 */
import { useQuery } from '@tanstack/react-query';
import { api } from '../api';
import type { WhoamiResponse } from '../api';

export function useWhoami() {
  return useQuery<WhoamiResponse>({
    queryKey: ['whoami'],
    queryFn: () => api.get<WhoamiResponse>('/api/auth/whoami'),
    // Longer stale time because whoami rarely changes and too-frequent polls
    // would trigger the sliding-window renewal on every pulse.
    staleTime: 30_000,
    refetchOnWindowFocus: true,
    retry: false,
  });
}
